
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb, Col, Row, Form, Card, Table, Container, Button, Alert } from '@themesberg/react-bootstrap';
import { useSelector } from 'react-redux';
import axiosInstance from "../../api/api";
import Preloader from "../../components/Preloader";
import Ranked from '../components/Ciem/Ranked';
import CardLayout from '../components/Layout/CardLayout';

export default () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Use local state for form inputs to allow editing, though initial values come from API
    const [inputs, setInputs] = useState({
        porcentajeEscenario1: 0,
        porcentajeEscenario2: 0,
        porcentajeEscenario3: 0
    });

    const ciemId = useSelector(state => state.ciem.ciemId);
    const [rankedForm, setRankedForm] = useState([]);

    useEffect(() => {
        fetchData();

        axiosInstance.get('/detailoption/option/value/rankedSeventeen').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });
    }, [ciemId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            // Fallback for testing if ciemId is missing or logic requires it
            const id = ciemId;
            if (!id) {
                setError("No CIEM ID selected.");
                setLoading(false);
                return;
            }

            const response = await axiosInstance.get(`/escenarioVenta/${id}`);
            // Handle nested data structure
            const apiData = response.data.data || response.data;
            setData(apiData);
            // Initialize form with API data if available
            setInputs({
                porcentajeEscenario1: apiData.porcentajeEscenario1 || 0,
                porcentajeEscenario2: apiData.porcentajeEscenario2 || 0,
                porcentajeEscenario3: apiData.porcentajeEscenario3 || 0
            });
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCalculate = async () => {
        setLoading(true);
        try {
            const id = ciemId;
            if (!id) {
                setError("No CIEM ID selected.");
                setLoading(false);
                return;
            }

            // Prepare data for POST request
            const updateData = {
                id: data?.id,
                porcentajeEscenario1: parseFloat(inputs.porcentajeEscenario1) || 0,
                porcentajeEscenario2: parseFloat(inputs.porcentajeEscenario2) || 0,
                porcentajeEscenario3: parseFloat(inputs.porcentajeEscenario3) || 0,
                ciem: id
            };

            // POST request to save and recalculate
            const response = await axiosInstance.post(`/escenarioVenta/`, updateData);
            // Handle nested data structure
            const apiData = response.data.data || response.data;
            setData(apiData);
            setError(null);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    if (!ciemId) {
        return (
            <Container className="mt-4">
                <Alert variant="warning">
                    Por favor, seleccione un CIEM para ver el Estado de Resultados.
                </Alert>
            </Container>
        );
    }

    if (loading) return <Preloader show={loading} />;

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item active>Estado de Resultados</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Estado de Resultados</h4>
                </div>
            </div>

            <Container className="px-0">
                <Card border="light" className="shadow-sm mb-4">
                    <Card.Body>
                        <h5 className="mb-4">Porcentajes de Escenario</h5>
                        <Form>
                            <Row>
                                <Col md={4} className="mb-3">
                                    <Form.Group id="porcentajeEscenario1">
                                        <Form.Label>Porcentaje Escenario 1</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="porcentajeEscenario1"
                                            value={inputs.porcentajeEscenario1}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4} className="mb-3">
                                    <Form.Group id="porcentajeEscenario2">
                                        <Form.Label>Porcentaje Escenario 2</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="porcentajeEscenario2"
                                            value={inputs.porcentajeEscenario2}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4} className="mb-3">
                                    <Form.Group id="porcentajeEscenario3">
                                        <Form.Label>Porcentaje Escenario 3</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="porcentajeEscenario3"
                                            value={inputs.porcentajeEscenario3}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="d-flex justify-content-end">
                                    <Button
                                        variant="primary"
                                        onClick={handleCalculate}
                                        disabled={loading}
                                    >
                                        {loading ? 'Calculando...' : 'Calcular'}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>

                <Card border="light" className="shadow-sm">
                    <Card.Body>
                        <h5 className="mb-4">Detalle Estado de Resultados</h5>
                        <Table responsive className="table-centered table-nowrap rounded mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th className="border-0">Rubro</th>
                                    <th className="border-0">Escenario 1</th>
                                    <th className="border-0">Escenario 2</th>
                                    <th className="border-0">Escenario 3</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && (
                                    <>
                                        {/* Ventas (V) */}
                                        <tr>
                                            <td>Ventas (V)</td>
                                            <td>{data.vescenario1 || '-'}</td>
                                            <td>{data.vescenario2 || '-'}</td>
                                            <td>{data.vescenario3 || '-'}</td>
                                        </tr>
                                        {/* Costo de mercancía vendida (CMV) */}
                                        <tr>
                                            <td>Costo de mercancía vendida (CMDI)</td>
                                            <td>{data.cmvEscenario1}</td>
                                            <td>{data.cmvEscenario2}</td>
                                            <td>{data.cmvEscenario3}</td>
                                        </tr>
                                        {/* Costo mano de obra directa (CMOD) */}
                                        <tr>
                                            <td>Costo mano de obra directa (CMOD)</td>
                                            <td>{data.cmod || '-'}</td>
                                            <td>{data.cmod || '-'}</td>
                                            <td>{data.cmod || '-'}</td>
                                        </tr>
                                        {/* Costos indirectos de fabricación semifijos (CIFf) */}
                                        <tr>
                                            <td>Costos indirectos de fabricación semifijos (CIFf)</td>
                                            <td>{data.ciff || '-'}</td>
                                            <td>{data.ciff || '-'}</td>
                                            <td>{data.ciff || '-'}</td>
                                        </tr>
                                        {/* Utilidad Bruta (UB) */}
                                        <tr className="fw-bold">
                                            <td>Utilidad Bruta (UB)</td>
                                            <td>{data.ubEscenario1}</td>
                                            <td>{data.ubEscenario2}</td>
                                            <td>{data.ubEscenario3}</td>
                                        </tr>
                                        {/* Costo fijo (CF) */}
                                        <tr>
                                            <td>Costo fijo (CF)</td>
                                            <td>{data.cf || '-'}</td>
                                            <td>{data.cf || '-'}</td>
                                            <td>{data.cf || '-'}</td>
                                        </tr>
                                        {/* Utilidad Operacional (UO) */}
                                        <tr className="fw-bold">
                                            <td>Utilidad Operacional (UO)</td>
                                            <td>{data.uoEscenario1}</td>
                                            <td>{data.uoEscenario2}</td>
                                            <td>{data.uoEscenario3}</td>
                                        </tr>
                                        {/* Intereses (I) */}
                                        <tr>
                                            <td>Intereses (I)</td>
                                            <td>{data.iescenario1 || '-'}</td>
                                            <td>{data.iescenario2 || '-'}</td>
                                            <td>{data.iescenario3 || '-'}</td>
                                        </tr>
                                        {/* Utilidad Antes de Impuestos (UAI) */}
                                        <tr className="fw-bold">
                                            <td>Utilidad Antes de Impuestos (UAI)</td>
                                            <td>{data.uaiEscenario1}</td>
                                            <td>{data.uaiEscenario2}</td>
                                            <td>{data.uaiEscenario3}</td>
                                        </tr>
                                        {/* Valor Impuesto a la Renta (Vt) */}
                                        <tr>
                                            <td>Valor Impuesto a la Renta (Vt)</td>
                                            <td>{data.vtEscenario1}</td>
                                            <td>{data.vtEscenario2}</td>
                                            <td>{data.vtEscenario3}</td>
                                        </tr>
                                        {/* Utilidad Neta (U) */}
                                        <tr className="fw-bold">
                                            <td>Utilidad Neta (U)</td>
                                            <td>{data.uescenario1 || '-'}</td>
                                            <td>{data.uescenario2 || '-'}</td>
                                            <td>{data.uescenario3 || '-'}</td>
                                        </tr>

                                    </>
                                )}
                                {!data && !loading && (
                                    <tr>
                                        <td colSpan={4} className="text-center">No hay datos disponibles.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>

            {/* Ranked - Calificación */}
            {(() => {
                const calificacion = <Ranked field={rankedForm} ciemId={ciemId} />;
                return <CardLayout value={"rankedSeventeen"} tablaComponent={calificacion} />;
            })()}
        </>
    );
};
